<template>
  <div class="container-fluid h-100">
    <!-- <div>all</div> -->
    <!-- <button @click="setStep">click</button> -->
    <div class="row h-100 justify-content-center align-items-center">
      <div class="col-auto">
        <div class="card card-custom shadow">
          <div class="card-body p-0">
            <div class="step1-panels" v-if="step == 1">
              <div class="left-side">
                <div class="left-side-bg"></div>
              </div>
              <div class="form-side">
                <div class="">
                  <h4 class="text-center fw-bolder text-navy-blue">
                    Prepaid Fiber Online Application
                  </h4>
                  <div class="text-center mt-3">
                    <strong
                      >Find out if your community already has Surf2Sawa</strong
                    >
                  </div>

                  <div class="my-5">
                    <form>
                      <div class="mb-3">
                        <label class="form-label">First Name *</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="First Name"
                          v-model="form.firstName"
                          autocomplete="off"
                          name="firstName"
                          :class="{
                            'is-invalid': submitted && $v.form.firstName.$error,
                          }"
                        />
                        <div
                          v-if="submitted && $v.form.firstName"
                          class="invalid-feedback"
                        >
                          This field is required
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Last Name *</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Last Name"
                          v-model="form.lastName"
                          name="lastName"
                          autocomplete="off"
                          :class="{
                            'is-invalid': submitted && $v.form.lastName.$error,
                          }"
                          v-validate="'required'"
                        />
                        <div
                          v-if="submitted && $v.form.lastName"
                          class="invalid-feedback"
                        >
                          This field is required
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Contact Number *</label>
                        <input
                          v-mask="'09 ### ### ###'"
                          type="tel"
                          name="mobileNumber"
                          autocomplete="off"
                          class="form-control"
                          placeholder="09 XXX XXX XXX"
                          v-model="form.mobileNumber"
                          :class="{
                            'is-invalid':
                              submitted && $v.form.mobileNumber.$error,
                          }"
                          v-validate="'required'"
                        />
                        <div
                          v-if="submitted && $v.form.mobileNumber"
                          class="invalid-feedback"
                        >
                          This field is required
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Email Address *</label>
                        <input
                          type="email"
                          class="form-control"
                          placeholder="Email Address"
                          autocomplete="off"
                          v-model="form.emailAddress"
                          name="emailAddress"
                          :class="{
                            'is-invalid':
                              submitted && $v.form.emailAddress.$error,
                          }"
                          v-validate="'required'"
                        />
                        <div
                          v-if="submitted && $v.form.emailAddress"
                          class="invalid-feedback"
                        >
                          This field is required
                        </div>
                      </div>
                      <div class="mb-3">
                        <div class="d-flex">
                          <input
                            class="form-check-input checkbox-theme me-3 align-self-center flex-shrink-0"
                            type="checkbox"
                            v-model="isChecked"
                          />

                          <label class="consent-label">
                            I expressly consent to the processing of my personal
                            information as outlined in the
                            <a
                              href="https://corporate.convergeict.com/privacy-notice"
                              target="_blank"
                              class="a2"
                            >
                              Privacy Policy,
                            </a>
                            which I read and understood.
                          </label>
                        </div>
                      </div>

                      <!-- <SearchLocation @fomattedLocation="getFomattedLocation" />

                    <small class="float-end">
                      <a href="" @click.prevent="showMaps()">Choose from Map</a>
                    </small> -->

                      <!-- <div class="mb-3 position-relative">
                      
                      <small class="float-end">
                        <a href="" @click.prevent="applyNow()">Choose from Map</a>
                      </small>
                    </div> -->
                      <!-- <div class="mb-3">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Select Region"
                      />
                    </div> -->

                      <div class="mt-3">
                        <button
                          class="btn px-5 btn-s2s-blue"
                          :class="{ 'btn-disabled': !isChecked }"
                          @click.prevent="setStep()"
                          :disabled="!isChecked"
                        >
                          <!-- <span
                            v-if="submitted"
                            class="spinner-border spinner-border-sm pl-5"
                            role="status"
                          >
                            <span class="visually-hidden">Loading...</span>
                          </span> -->
                          Continue
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="step == 2">
              <div class="col-lg-12 my-5">
                <div class="mx-4">
                  <h4 class="text-center fw-bolder text-navy-blue">
                    Prepaid Fiber Online Application
                  </h4>
                  <div class="text-center mt-3">
                    <strong
                      >Find out if your community already has Surf2Sawa</strong
                    >
                  </div>

                  <div class="my-5">
                    <form class="row" action="" v-if="step == 2">
                      <div class="mb-3 col-md-4">
                        <label class="form-label">Region *</label>
                        <select
                          class="form-control"
                          name="region"
                          :class="{
                            'is-invalid': submitted && $v.form.region.$error,
                          }"
                          v-validate="'required'"
                          @change.prevent="regionSelected($event)"
                          :disabled="location.regions < 1"
                          v-model="form.region"
                        >
                          <option value="" selected disabled hidden>
                            Select Region
                          </option>
                          <option
                            v-for="(region, i) in location.regions"
                            :key="i"
                            :value="region.name"
                            :data-id="region.code"
                            v-text="region.name"
                          ></option>
                        </select>
                        <div
                          v-if="submitted && $v.form.region.$error"
                          class="invalid-feedback"
                        >
                          This field is required
                        </div>
                      </div>
                      <!-- {{ $v.form.firstName }} -->
                      <div class="mb-3 col-md-4">
                        <label class="form-label">Province *</label>
                        <select
                          class="form-control"
                          name="province"
                          :class="{
                            'is-invalid': submitted && $v.form.province.$error,
                          }"
                          v-validate="'required'"
                          @change.prevent="provinceSelected($event)"
                          :disabled="location.provinces < 1"
                          v-model="form.province"
                        >
                          <option value="" selected disabled hidden>
                            Select Province
                          </option>
                          <option
                            v-for="(province, i) in location.provinces"
                            :key="i"
                            :value="province.provinceName"
                            :data-id="province.provinceCode"
                            v-text="province.provinceName"
                          ></option>
                        </select>
                        <div
                          v-if="submitted && $v.form.province.$error"
                          class="invalid-feedback"
                        >
                          This field is required
                        </div>
                      </div>

                      <div class="mb-3 col-md-4">
                        <label class="form-label">City / Municipal *</label>
                        <select
                          class="form-control"
                          name="city"
                          :class="{
                            'is-invalid': submitted && $v.form.city.$error,
                          }"
                          v-validate="'required'"
                          @change.prevent="citySelected($event)"
                          :disabled="location.cities < 1"
                          v-model="form.city"
                        >
                          <option value="" selected disabled hidden>
                            Select City
                          </option>
                          <option
                            v-for="(city, i) in location.cities"
                            :key="i"
                            :value="city.cityName"
                            :data-id="city.cityCode"
                            v-text="city.cityName"
                          ></option>
                        </select>
                        <div
                          v-if="submitted && $v.form.city.$error"
                          class="invalid-feedback"
                        >
                          This field is required
                        </div>
                      </div>

                      <div class="mb-3 col-md-4" v-if="form.city != ''">
                        <label class="form-label">Address Type *</label>
                        <select
                          class="form-control"
                          name="city"
                          :class="{
                            'is-invalid':
                              submitted && $v.form.addressType.$error,
                          }"
                          v-validate="'required'"
                          :disabled="location.cities < 1"
                          v-model="form.addressType"
                          @change.prevent="selectAddressType()"
                        >
                          <option value="" selected disabled>
                            Address Type
                          </option>
                          <option
                            v-for="(type, i) in addressTypes"
                            :key="i"
                            :value="type"
                            v-text="type"
                          ></option>
                        </select>
                        <div
                          v-if="submitted && $v.form.addressType.$error"
                          class="invalid-feedback"
                        >
                          This field is required
                        </div>
                      </div>

                      <div
                        class="mb-3 col-md-4"
                        v-if="form.addressType == 'Ecozone'"
                      >
                        <label class="form-label">Ecozones *</label>
                        <select
                          class="form-control"
                          name="city"
                          :class="{
                            'is-invalid': submitted && $v.form.ecozone.$error,
                          }"
                          v-validate="'required'"
                          :disabled="location.cities < 1"
                          v-model="form.ecozone"
                          @change.prevent="selectEcozone($event)"
                        >
                          <option value="" selected disabled>Ecozone</option>
                          <option
                            v-for="(type, i) in ecozones"
                            :key="i"
                            :value="type.barangayOrSEZName"
                            v-text="type.barangayOrSEZName"
                            :data-id="type.barangayOrSEZCode"
                          ></option>
                        </select>
                        <div
                          v-if="submitted && $v.form.ecozone.$error"
                          class="invalid-feedback"
                        >
                          This field is required
                        </div>
                      </div>

                      <div
                        class="mb-3 col-md-4"
                        v-if="form.addressType == 'Barangay'"
                      >
                        <label class="form-label">Barangay *</label>
                        <select
                          class="form-control"
                          name="barangay"
                          :class="{
                            'is-invalid': submitted && $v.form.barangay.$error,
                          }"
                          v-validate="'required'"
                          :disabled="location.barangay < 1"
                          v-model="form.barangay"
                          @change.prevent="barangaySelected($event)"
                        >
                          <option value="" selected disabled hidden>
                            Select Barangay
                          </option>
                          <option
                            v-for="(brgy, i) in location.barangay"
                            :key="i"
                            :value="brgy.barangayOrSEZName"
                            :data-id="brgy.barangayOrSEZCode"
                            v-text="brgy.barangayOrSEZName"
                          ></option>
                        </select>
                        <div
                          v-if="submitted && $v.form.barangay.$error"
                          class="invalid-feedback"
                        >
                          This field is required
                        </div>
                      </div>

                      <div
                        class="mb-3 col-md-4"
                        v-if="
                          form.addressType == 'Barangay' && form.barangay != ''
                        "
                      >
                        <label class="form-label">Location Type *</label>
                        <select
                          class="form-control"
                          name="city"
                          :class="{
                            'is-invalid':
                              submitted && $v.form.locationType.$error,
                          }"
                          v-validate="'required'"
                          :disabled="location.cities < 1"
                          v-model="form.locationType"
                          @change.prevent="selectLocationType($event)"
                        >
                          <option value="" selected disabled>
                            Location Type
                          </option>
                          <option
                            v-for="(type, i) in locationTypes"
                            :key="i"
                            :value="type"
                            v-text="type"
                          ></option>
                        </select>
                        <div
                          v-if="submitted && $v.form.locationType.$error"
                          class="invalid-feedback"
                        >
                          This field is required
                        </div>
                      </div>

                      <div
                        class="mb-3 col-md-4"
                        v-if="
                          form.addressType == 'Barangay' &&
                          (form.locationType == 'Building' ||
                            form.locationType == 'Subdivision')
                        "
                      >
                        <label class="form-label">{{
                          form.locationType
                        }}</label>
                        <select
                          class="form-control"
                          name="city"
                          v-validate="'required'"
                          :disabled="locationTypeList.length <= 0"
                          v-model="form.buildingOrSubdivision"
                          @change.prevent="selectBuildingSubs($event)"
                        >
                          <option value="" selected disabled>
                            Select {{ form.locationType }}
                          </option>
                          <option
                            v-for="(type, i) in locationTypeList"
                            :key="i"
                            :value="type.buildingOrSubdiOrCIZCode"
                            :data-id="type.buildingOrSubdiOrCIZCode"
                            v-text="type.buildingOrSubdiOrCIZName"
                          ></option>
                        </select>
                        <div class="invalid-feedback">
                          This field is required
                        </div>
                      </div>

                      <div class="mb-3 col-md-12">
                        <p class="text-center">
                          Please drag the pin on your exact location.
                        </p>
                        <GmapMap
                          :center="centerLocation"
                          :zoom="15"
                          :options="mapOptions"
                          style="width: 100%; height: 400px"
                        >
                          <GmapMarker
                            :position="centerLocation"
                            :draggable="true"
                            @dragend="updateCoordinates"
                          />
                        </GmapMap>
                      </div>

                      <div class="mt-3 col-12 col-md-4 col-lg-5 mx-auto">
                        <button
                          :disabled="btnCheckAvailablity"
                          class="btn w-100 btn-s2s-blue"
                          @click.prevent="reverseGeocoding()"
                        >
                          <span
                            v-if="btnCheckAvailablity"
                            class="spinner-border spinner-border-sm pl-5"
                            role="status"
                          >
                            <span class="visually-hidden">Loading...</span>
                          </span>
                          Check Serviceability
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-maps
      :show="modalMaps.isShow"
      @close="modalMaps.isShow = !modalMaps.isShow"
    ></modal-maps>

    <NoticeModal ref="noticeModal" />
    <Toast
      ref="toast"
      bgClass="bg-danger"
      position="bottom-0 start-50 translate-middle-x"
    />
    <not-serviceable-modal ref="notServiceableModal"></not-serviceable-modal>
  </div>
</template>

<script>
import { email, required, requiredIf } from "vuelidate/lib/validators";
import ModalMaps from "../components/ModalMaps.vue";
// import SearchLocation from "../components/SearchLocation.vue";
import { googleApiKey } from "../../http-common";
import axios from "axios";
import NoticeModal from "../components/NoticeModal.vue";
import Toast from "../components/Toast.vue";
import NotServiceableModal from "../components/NotServiceableModal.vue";

export default {
  components: {
    ModalMaps,
    // SearchLocation,
    NoticeModal,
    Toast,
    NotServiceableModal,
  },

  data() {
    return {
      mapOptions: {
        streetViewControl: false,
      },
      modalMaps: {
        isShow: false,
      },
      address: null,

      currentPlace: null,
      submitted: false,

      form: {
        firstName: "",
        lastName: "",
        emailAddress: "",
        mobileNumber: "",
        region: "",
        province: "",
        city: "",
        barangay: "",
        addressType: "",
        locationType: "",
        buildingOrSubdivision: "",
        buildingOrSubdiviCode: "",
        ecozone: "",
        regionCode: "",
        provinceCode: "",
        cityCode: "",
        barangayCode: "",
      },
      isChecked: false,

      addressTypes: ["Ecozone", "Barangay"],
      locationTypes: ["Subdivision", "Building", "Others"],
      buildingAndSubs: [],
      selecteBarangayId: "",

      step: 1,

      availableAreas: [
        // {
        //   municipalities: ["All"],
        //   province: "Metro Manila",
        //   region: "NCR",
        // },
        // {
        //   municipalities: ["Meycauayan", "Marilao", "Bocaue", "Santa Maria"],
        //   province: "Bulacan",
        //   region: "Central Luzon",
        // },
        // {
        //   municipalities: [
        //     "Tayabas",
        //     "Lucena",
        //     "Lucban",
        //     "Sariaya",
        //     "Candelaria",
        //     "Pagbilao",
        //   ],
        //   province: "Quezon",
        //   region: "Calabarzon",
        // },
        // {
        //   municipalities: ["General Trias"],
        //   province: "Cavite",
        //   region: "Calabarzon",
        // },
        // {
        //   municipalities: ["Naga"],
        //   province: "Camarines Sur",
        //   region: "Bicol",
        // },
      ],

      btnCheckAvailablity: false,
      ecozones: [],

      // location: {
      //   region: "",
      //   province: "",
      //   municipal: "",
      // },

      location: {
        regions: [],
        provinces: [],
        cities: [],
        barangay: [],
      },
      locationTypeList: [],

      notAllowedAreas: [
        {
          province: "Ilocos Norte",
          cities: ["Banna"], // allowed cities
        },
        {
          province: "Leyte",
          cities: [], // blank means all city not allowed
        },
        {
          province: "Isabela",
          cities: ["Tumauini"],
        },
        {
          province: "Palawan",
          cities: [],
        },
        {
          province: "Abra",
          cities: [],
        },
        {
          province: "Agusan del Sur",
          cities: [],
        },
        {
          province: "Aklan",
          cities: [],
        },
        {
          province: "Bohol",
          cities: [],
        },
        {
          province: "Bukidnon",
          cities: [],
        },
        {
          province: "Cagayan",
          cities: [],
        },
        {
          province: "Camarines Norte",
          cities: ["Daet"],
        },
        {
          province: "Camarines Sur",
          cities: ["Nabua", "Buhi"],
        },
        {
          province: "Albay",
          cities: ["Legazpi City", "Tabaco City"],
        },
        {
          province: "Capiz",
          cities: [],
        },
        {
          province: "Davao del Norte",
          cities: [],
        },
        {
          province: "Ifugao",
          cities: [],
        },
        {
          province: "Ilocos Sur",
          cities: [],
        },
        {
          province: "Iloilo",
          cities: ["Iloilo City"],
        },
        {
          province: "Kalinga",
          cities: [],
        },
        {
          province: "Masbate",
          cities: ["Masbate City"],
        },
        {
          province: "Negros Occidental",
          cities: ["Cadiz City"],
        },
        {
          province: "Negros Oriental",
          cities: [],
        },
        {
          province: "Nueva Ecija",
          cities: ["Bongabon", "San Jose City", "Talavera", "Cabiao"],
        },
        {
          province: "Nueva Vizcaya",
          cities: ["Bayombong"],
        },
        {
          province: "Palawan",
          cities: [],
        },
        {
          province: "Quirino",
          cities: [],
        },
        {
          province: "South Cotabato",
          cities: [],
        },
        {
          province: "Zambales",
          cities: [],
        },
        {
          province: "Tarlac",
          cities: ["Tarlac City", "Tariji"],
        },
        {
          province: "Pampanga",
          cities: [
            "Mabalacat",
            "Floridablanca",
            "Cacutud",
            "San Fernando",
            "Arayat",
          ],
        },
        {
          province: "Aklan",
          cities: ["Kalibo"],
        },

        {
          province: "Quezon",
          cities: [
            "Atimonan",
            "Plaridel",
            "Gumaca",
            "Lopez",
            "Calauag",
            "Tagkawayan",
            "Guinayangan",
            "Buenavista",
            "Lucena",
            "Sariaya",
            "Pagbilao",
            "General Luna",
            "Mauban",
            "Candelaria",
            "Sampaloc",
            "Tiaong",
            "Dolores",
            "Lucban",
            "San Antonio",
            "Pitogo",
          ],
        },

        {
          province: "Davao del Sur",
          cities: ["Davao City"],
        },

        {
          province: "Laguna",
          cities: [
            "San Pablo City",
            "Alaminos",
            "Calauan",
            "Victoria",
            "Cabuyao",
            "Santa Maria",
            "Nagcarlan",
            "Liliw",
            "Majayjay",
            "Rizal",
            "Luisiana",
            "Los Baños",
            "Biñan",
          ],
        },
      ],

      centerLocation: {
        lat: 14.5935087,
        lng: 121.1001506,
      },
    };
  },

  methods: {
    async toast(message) {
      await this.$refs.toast.open({ message: message });
    },

    async setStep() {
      this.submitted = true;

      this.$v.$touch();
      // console.log(this.$v.$invalid);
      // if (this.$v.$invalid) return;

      const s = await this.$validator.validate().then((valid) => {
        return valid;
      });

      if (!s) {
        // this.toast("Please fill in all required fields.");
        // this.submitted = false;
        return false;
      }
      this.submitted = false;
      this.step = this.step == 1 ? 2 : 1;
    },

    selectAddressType() {
      if (this.form.addressType == "Ecozone") {
        // alert("hey");
        console.log("ecozone");
      }
    },

    async getEcozones(cityCode) {
      await this.$location
        .get(`/economic-zone?cityCode=${cityCode}`)
        .then((response) => {
          const res = response.data.data;
          console.log(res);
          this.ecozones = res.economicZones;
        })
        .catch((e) => {
          console.log(e);
          this.loadingBtn = false;
        });
    },

    async applyNow(payload) {
      // console.log(this.getCenter);
      // this.getLocation();
      this.submitted = true;
      this.btnCheckAvailablity = true;
      // const payload = {
      //   lat: this.getCenter.lat,
      //   long: this.getCenter.lng,
      // };

      // this.reverseGeocoding(payload);

      await this.$api
        .post("/acquisition/location", payload)
        .then((response) => {
          this.submitted = false;
          this.btnCheckAvailablity = false;
          const res = response.data;
          if (!res.data.available) {
            this.$store
              .dispatch("ADD_NOT_SERVICEABLE", { show: true, data: res })
              .then(() => {
                this.$store.dispatch("ADD_PREDATA", this.form);
                // this.$router.push({ path: "not-serviceable" });
                this.$refs.notServiceableModal.open();
              });

            return;
          }

          // this.$store.dispatch("ADD_PREDATA", res.data);
          // this.$store.dispatch("ADD_APPLICATION_FORM", true).then(() => {
          //   // this.portReserve(res.data.referenceNumber)
          //   // this.$router.push({ path: "application-form" });
          //   this.$router.push({ path: "payment-selection" });
          // });

          // this.$store.dispatch("ADD_PREDATA", res.data);
          res.data.latitude = payload.lat;
          res.data.longitude = payload.long;
          const form = { ...this.form };
          res.data.stepData = form;
          this.$store.dispatch("ADD_PREDATA", res.data).then(() => {
            this.$router.push({ path: "payment-selection" });
          });
        })
        .catch((e) => {
          this.submitted = false;
          this.btnCheckAvailablity = false;
          console.log(e);
        });
    },

    showMaps() {
      this.modalMaps.isShow = true;
    },

    reFormatAccountNumber(num) {
      return num.replace(/\s+/g, "").replace("+", "");
    },

    clearLocation() {
      // this.location.region = "";
      // this.location.province = "";
      // this.location.municipal = "";
      this.location = {
        region: "",
        province: "",
        municipal: "",
      };
    },

    // old reverseGeocoding
    // async reverseGeocoding() {
    //   this.location = this.submitted = true;
    //   this.clearLocation();
    //   const position = {
    //     lat: this.getCenter.lat,
    //     long: this.getCenter.lng,
    //   };

    //   await setTimeout(() => {
    //     axios
    //       .get(
    //         `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.lat},${position.long}&key=${googleApiKey}`
    //       )
    //       .then((result) => {
    //         // console.log(result);
    //         this.submitted = false;
    //         const res = result.data;
    //         let parts = res.results[0].address_components;
    //         parts.forEach((part) => {
    //           if (part.types.includes("administrative_area_level_1")) {
    //             this.location.region = part.short_name;
    //           }

    //           if (part.types.includes("administrative_area_level_2")) {
    //             this.location.province = part.long_name;
    //           }

    //           if (part.types.includes("locality")) {
    //             this.location.municipal = part.long_name;
    //           }
    //         });

    //         var filterRegion = this.availableAreas.filter((item) => {
    //           return item.region === this.location.region;
    //         });
    //         // console.log(filterRegion);

    //         // exists in selected area
    //         if (filterRegion.length > 0) {
    //           var filterProvince = filterRegion.filter((item) => {
    //             return item.province === this.location.province;
    //           });

    //           if (filterProvince.length > 0) {
    //             // check if has a province
    //             if (filterProvince[0].municipalities.includes("All")) {
    //               // alert("allowed all");
    //               this.applyNow(position);
    //               return;
    //             } else {
    //               if (
    //                 filterProvince[0].municipalities.includes(
    //                   this.location.municipal
    //                 )
    //               ) {
    //                 // alert("many municipal allow");
    //                 this.applyNow(position);
    //                 return;
    //               }
    //             }
    //           } else {
    //             if (filterRegion[0].region === "NCR") {
    //               // special for NCR
    //               if (filterRegion[0].municipalities.includes("All")) {
    //                 // alert("allowed ncr");
    //                 this.applyNow(position);
    //                 return;
    //               } else {
    //                 if (
    //                   filterRegion[0].municipalities.includes(
    //                     this.location.municipal
    //                   )
    //                 ) {
    //                   // alert("multiple only ncr");
    //                   this.applyNow(position);
    //                   return;
    //                 }
    //               }
    //             }
    //           }
    //         }

    //         this.$swal(
    //           "Sorry",
    //           "Your area is not yet serviceable. Your application will not be processed.",
    //           "error"
    //         );
    //         return;
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //         return false;
    //       });
    //   }, 1000);
    // },

    async reverseGeocoding() {
      // if (this.GET_CENTER_PLACE === "" || this.GET_CENTER_PLACE === null) {
      //   this.$refs.toast.open({ message: "Please select your location." });
      //   return;
      // }

      this.submitted = true;
      this.$v.$touch();
      // console.log(this.$v.$invalid);
      // if (this.$v.$invalid) return;

      const s = await this.$validator.validate().then((valid) => {
        return valid;
      });

      if (!s) {
        // this.toast("Please fill in all required fields.");
        // this.submitted = false;
        return false;
      }

      this.btnCheckAvailablity = true;
      // this.location = this.submitted = true;
      // this.clearLocation();
      const position = {
        lat: this.getCenter.lat,
        long: this.getCenter.lng,
      };

      await setTimeout(() => {
        axios
          .get(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${position.lat},${position.long}&key=${googleApiKey}`
          )
          .then((result) => {
            console.log(result);
            this.submitted = false;
            // const res = result.data;
            // let parts = res.results[0].address_components;
            // parts.forEach((part) => {
            //   if (part.types.includes("administrative_area_level_1")) {
            //     this.location.region = part.short_name;
            //   }

            //   if (part.types.includes("administrative_area_level_2")) {
            //     this.location.province = part.long_name;
            //   }

            //   if (part.types.includes("locality")) {
            //     this.location.municipal = part.long_name;
            //   }
            // });

            // var filterProvince = this.notAllowedAreas.filter((item) => {
            //   return item.province === this.location.province;
            // });

            // console.log(filterProvince);

            // if (filterProvince.length) {
            //   const filterCity = filterProvince.filter((item) => {
            //     return item.cities.includes(this.location.municipal);
            //   });

            //   if (filterCity.length) {
            //     this.applyNow(position);
            //     return;
            //   }

            //   this.$swal(
            //     "Sorry",
            //     "Your area is not yet serviceable. Your application will not be processed.",
            //     "error"
            //   );

            //   return;
            // }

            const form = { ...this.form };
            const personalInfo = {
              firstName: form.firstName,
              lastName: form.lastName,
              emailAddress: form.emailAddress,
              mobileNumber: this.reFormatNumber(form.mobileNumber),
              privacyConsent: this.isChecked,
              building:
                form.locationType == "Building"
                  ? form.buildingOrSubdiviCode
                  : "",
              subdivision:
                form.locationType == "Subdivision"
                  ? form.buildingOrSubdiviCode
                  : "",
            };
            this.btnCheckAvailablity = false;
            this.applyNow({ ...position, ...personalInfo });
            // console.log("submit");
          })
          .catch((err) => {
            // console.log(err);
            this.$refs.toast.open({ message: err });
            this.btnCheckAvailablity = false;
            return false;
          });
      }, 1000);

      //
    },
    reFormatNumber(num) {
      // return num.replace(/\s+/g, "").replace("0", "");
      if (num && num.indexOf("63") == 0) {
        return num.replace(/\s+/g, "");
      }
      return "63" + num.substring(1).replace(/\s+/g, "");
    },
    async getGeocode(address) {
      try {
        const response = await axios.get(
          "https://maps.googleapis.com/maps/api/geocode/json",
          {
            params: {
              address: address,
              key: googleApiKey,
            },
          }
        );

        // console.log(response.data);
        this.parseGeocodeResponse(response.data);
      } catch (error) {
        console.error("Error fetching geocode:", error);
      }
    },

    parseGeocodeResponse(data) {
      if (data && data.status === "OK") {
        const results = data.results[0];
        const latLng = results.geometry.location;
        const addressComponents = results.address_components;

        // Create an object to hold the parsed data
        const addressInfo = {
          latitude: latLng.lat,
          longitude: latLng.lng,
        };

        // Parse address components
        addressComponents.forEach((component) => {
          if (component.types.includes("administrative_area_level_1")) {
            addressInfo.region = component.long_name;
          }
          if (component.types.includes("administrative_area_level_2")) {
            addressInfo.province = component.long_name;
          }
          if (component.types.includes("locality")) {
            addressInfo.city = component.long_name;
          }
          if (component.types.includes("sublocality_level_1")) {
            addressInfo.barangay = component.long_name;
          }
        });

        // this.addressInfo = addressInfo;

        this.centerLocation = {
          lat: addressInfo.latitude,
          lng: addressInfo.longitude,
        };
        // const center = {
        //   lat: position.coords.latitude,
        //   lng: position.coords.longitude,
        // };
        // return center
        this.$store.dispatch("ADD_CENTER", this.centerLocation);
      } else {
        console.error(
          "Geocode was not successful for the following reason:",
          data.status
        );
      }
    },

    setLatLong(lat, long) {
      // console.log(lat, long);
      this.centerLocation = {
        lat: parseFloat(lat),
        lng: parseFloat(long),
      };
      this.$store.dispatch("ADD_CENTER", this.centerLocation);
    },

    async getLocation() {
      navigator.geolocation.getCurrentPosition((position) => {
        const center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        // return center
        this.$store.dispatch("ADD_CENTER", center);
      });

      await setTimeout(() => {
        axios
          .get(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${this.getCenter.lat},${this.getCenter.lng}&key=${googleApiKey}`
          )
          .then((result) => {
            // console.log(result);
            const res = result.data;

            let parts = res.results[0].address_components;
            console.log(parts);
            parts.forEach((part) => {
              if (part.types.includes("administrative_area_level_1")) {
                console.log("region", part.short_name);
              }
            });
            this.$store.dispatch(
              "ADD_CURRENT_PLACE",
              res.results[0].formatted_address
            );
            console.log(res);
          })
          .catch((err) => {
            console.log(err);
          });
      }, 1000);
    },

    async showNotice() {
      await this.$refs.noticeModal.open();
    },

    async getAvailableAreas() {
      await this.$api
        .get("/online-application-config")
        .then((response) => {
          const res = response.data;
          this.availableAreas = res.data.availableAreas;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    getFomattedLocation({ data, done }) {
      if (done) {
        // this.location = data;
        console.log(data);
      }
    },

    async loadLocation(base = "regions", params = "") {
      await this.$location
        .get(`${base}?${params}`)
        .then((response) => {
          const res = response.data.data;

          // console.log("ressss", res);
          if (base === "regions") {
            this.location.regions = res.regions;
          }
          if (base === "provinces") {
            this.location.provinces = res.provinces;
          }
          if (base === "cities") {
            this.location.cities = res.cities;
          }
          if (base === "barangay") {
            this.location.barangay = res.barangay;
          }
          // return (res);
        })
        .catch((e) => {
          console.log(e);
          this.loadingBtn = false;
        });
    },

    regionSelected(e) {
      const regionId = e.target ? e.target.selectedOptions[0].dataset.id : e;
      console.log(e.target);
      this.form.regionCode = regionId;
      this.loadLocation("provinces", `regionCode=${regionId}`);
      this.form.province = "";
      this.form.city = "";
      this.form.barangay = "";
      this.getGeocode(this.form.region);
    },

    provinceSelected(e) {
      const provinceId = e.target ? e.target.selectedOptions[0].dataset.id : e;
      this.form.provinceCode = provinceId;

      console.log(provinceId);
      console.table(this.location.provinces);

      const p = this.location.provinces.filter((el) => {
        if (el.provinceCode === provinceId) {
          return el;
        }
      });

      this.setLatLong(p[0].latitude, p[0].longitude);

      this.loadLocation("cities", `provinceCode=${provinceId}`);
      this.form.city = "";
      this.form.barangay = "";
      // this.getGeocode(this.form.province + " " + this.form.region);
    },

    citySelected(e) {
      const cityId = e.target ? e.target.selectedOptions[0].dataset.id : e;
      this.form.cityCode = cityId;
      this.$store.dispatch("ADD_CITYCODE", cityId);
      this.loadLocation("barangay", `cityCode=${cityId}`);
      this.getEcozones(cityId);

      const p = this.location.cities.filter((el) => {
        if (el.cityCode === cityId) {
          return el;
        }
      });

      this.setLatLong(p[0].latitude, p[0].longitude);
      // this.form.city = ""
      this.form.barangay = "";
      // this.getGeocode(this.form.city);
      // this.getGeocode(
      //   this.form.city + " " + this.form.province + " " + this.form.region
      // );
    },

    barangaySelected(e) {
      const selecteBarangayId = e.target
        ? e.target.selectedOptions[0].dataset.id
        : e;
      this.selecteBarangayId = selecteBarangayId;
      this.form.barangayCode = selecteBarangayId;

      console.log(this.location.barangay, selecteBarangayId);
      const p = this.location.barangay.filter((el) => {
        if (el.barangayOrSEZCode === selecteBarangayId) {
          return el;
        }
      });

      // console.log(p);

      this.setLatLong(p[0].latitude, p[0].longitude);

      // this.getGeocode(
      //   this.form.barangay +
      //     " " +
      //     this.form.city +
      //     " " +
      //     this.form.province +
      //     " " +
      //     this.form.region
      // );
    },

    selectBuildingSubs(e) {
      console.log(e);
      const code = e.target ? e.target.selectedOptions[0].dataset.id : e;
      const buildingOrSubdivision = this.form.buildingOrSubdivision;
      this.form.buildingOrSubdiviCode = code;
      console.log(buildingOrSubdivision, code);
      const p = this.locationTypeList.filter((el) => {
        if (el.buildingOrSubdiOrCIZCode === code) {
          return el;
        }
      });

      console.log(p);

      this.setLatLong(p[0].latitude, p[0].longitude);

      // this.getGeocode(
      //   buildingOrSubdivision +
      //     " " +
      //     this.form.barangay +
      //     " " +
      //     this.form.city +
      //     " " +
      //     this.form.province +
      //     " " +
      //     this.form.region
      // );
    },

    selectEcozone(e) {
      const selecteBarangayId = e.target
        ? e.target.selectedOptions[0].dataset.id
        : e;
      // this.selecteBarangayId = selecteBarangayId;
      console.log(selecteBarangayId);

      this.getGeocode(
        this.form.ecozone +
          " " +
          this.form.city +
          " " +
          this.form.province +
          " " +
          this.form.region
      );
    },

    selectLocationType(e) {
      console.log(e.target);
      console.log(this.form.locationType);
      const type = this.form.locationType;

      this.form.buildingOrSubdivision = "";
      this.form.buildingOrSubdiviCode = "";
      if (type == "Subdivision") {
        this.getBuildingOrSubs(
          "subdivisions",
          `barangayCode=${this.selecteBarangayId}`
        );
      }

      if (type == "Building") {
        this.getBuildingOrSubs(
          "buildings",
          `barangayCode=${this.selecteBarangayId}`
        );
      }
    },

    async getBuildingOrSubs(base = "", params = "") {
      await this.$location
        .get(`${base}?${params}`)
        .then((response) => {
          const res = response.data.data;
          this.locationTypeList = res[base];
          console.log(base, res);
        })
        .catch((e) => {
          console.log(e);
          this.loadingBtn = false;
        });
    },

    async updateCoordinates(location) {
      const center = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };

      this.$store.dispatch("ADD_CENTER", center);

      try {
        var { data } = await axios.get(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${center.lat},${center.lng}&key=${googleApiKey}`
        );
        if (data.error_message) {
          console.log(data.error_message);
        } else {
          // this.autocomplete = data.results[0].formatted_address;
          this.$store.dispatch(
            "ADD_CURRENT_PLACE",
            data.results[0].formatted_address
          );
        }
      } catch (error) {
        console.log(error.message);
      }
    },
  },

  created() {
    // this.showLocationModal();
    this.getAvailableAreas();
    this.loadLocation();
    // if (Object.keys(this.getCenter).length === 0) {
    //   this.getLocation();
    // }

    this.$store.dispatch("ADD_APPLICATIONFORMDATA", {});
    this.$store.dispatch("ADD_PREDATA", {});
    this.$store.dispatch("ADD_REFNUMBER", "");
    this.$store.dispatch("ADD_OTP_VERIFIED", false);

    const query = this.$route.query;

    if (Object.keys(query).length !== 0) {
      localStorage.setItem("code", query.code);
      this.$store.dispatch("ADD_AFFILIATECODE", query.code);
    }

    const code = localStorage.getItem("code");
    this.$store.dispatch("ADD_AFFILIATECODE", code);

    // if (Object.keys(query).length === 0) {
    //   this.$store.dispatch("ADD_AFFILIATECODE", "");
    // } else {
    //   this.$store.dispatch("ADD_AFFILIATECODE", query.code);
    // }
    // const accountNum = localStorage.getItem("accNum");
    // if (accountNum) {
    //   this.accountNumber = accountNum;
    // }
  },

  validations() {
    const self = this;
    return {
      form: {
        firstName: {
          required,
        },
        lastName: {
          required,
        },
        // gender: "MALE",
        mobileNumber: {
          required,
        },
        emailAddress: {
          required,
          email,
        },
        region: {
          required: requiredIf(function () {
            return self.step == 2;
          }),
        },
        province: {
          required: requiredIf(function () {
            return self.step == 2;
          }),
        },

        city: {
          required: requiredIf(function () {
            return self.step == 2;
          }),
        },
        addressType: {
          required: requiredIf(function () {
            return self.step == 2;
          }),
        },
        barangay: {
          required: requiredIf(function (e) {
            console.log(e);
            return self.step == 2 && e.addressType == "Barangay";
          }),
        },

        econzone: {
          required: requiredIf(function (e) {
            console.log(e);
            return self.step == 2 && e.addressType == "Ecozone";
          }),
        },
        // addressType: { required: requiredIf(this.step == 2) },
        locationType: {
          required: requiredIf(function () {
            return self.step == 2;
          }),
        },
      },
      accountNumber: {
        required,
      },
    };
  },

  mounted() {
    // this.showNotice();
  },

  computed: {
    getCenter() {
      return this.$store.getters.GET_CENTER;
    },

    GET_CENTER_PLACE() {
      return this.$store.getters.GET_CENTER_PLACE;
    },
  },
};
</script>
